import React__default from 'react';
import { B as BluredBackgroundImage, I as Image } from './Card.style-512503ac.js';
import LazyLoad from 'react-lazy-load';

function CardImage(_a) {
    var src = _a.src, alt = _a.alt, lazyload = _a.lazyload, _b = _a.blur, blur = _b === void 0 ? false : _b;
    if (lazyload) {
        return (React__default.createElement(LazyLoad, { debounce: false, throttle: 100 },
            React__default.createElement(React__default.Fragment, null,
                blur && React__default.createElement(BluredBackgroundImage, { imgSrc: src }),
                React__default.createElement(Image, { src: src, alt: alt }))));
    }
    return (React__default.createElement(React__default.Fragment, null,
        blur && React__default.createElement(BluredBackgroundImage, { imgSrc: src }),
        React__default.createElement(Image, { src: src, alt: alt })));
}

export { CardImage as C };
//# sourceMappingURL=CardImage-39cbfff0.js.map
